import React, { useEffect, useState } from 'react';
import { Star, ExternalLink } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

const GoogleIcon = () => (
  <svg className="w-4 h-4" viewBox="0 0 24 24">
    <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
    <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
    <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
    <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
  </svg>
);

export const DepoimentosSection = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    fetch(`${API_URL}/api/google-reviews`)
      .then(r => (r.ok ? r.json() : null))
      .then(setData)
      .catch(() => {});
  }, []);

  const reviews = (data?.reviews || []).filter(r => r.text).slice(0, 4);
  if (!reviews.length) return null;

  return (
    <article className="mb-16" aria-labelledby="depoimentos-title" data-testid="shoficina-depoimentos">
      <h2 id="depoimentos-title" className="text-2xl font-bold text-white text-center mb-2">
        <Star className="w-6 h-6 inline mr-2 text-yellow-400 fill-yellow-400" /> Quem usa, recomenda
      </h2>
      <div className="flex items-center justify-center gap-2 mb-8">
        <GoogleIcon />
        <p className="text-slate-400 text-sm">
          Avaliações reais do Google —{' '}
          <span className="text-yellow-400 font-semibold">{Number(data.rating).toFixed(1)} ★</span>
          {' '}· {data.review_count} avaliações
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        {reviews.map((r, i) => (
          <figure key={r.review_uri || i} className="bg-slate-800/60 border border-slate-700/50 rounded-2xl p-6 relative hover:border-yellow-500/30 transition-colors" data-testid={`google-review-${i}`}>
            <div className="flex items-center justify-between mb-3">
              <div className="flex gap-0.5">
                {[...Array(Math.round(r.stars || 5))].map((_, s) => (
                  <Star key={s} className="w-4 h-4 text-yellow-400 fill-yellow-400" />
                ))}
              </div>
              {r.relative_time && <span className="text-slate-500 text-xs">{r.relative_time}</span>}
            </div>
            <blockquote className="text-slate-300 text-sm leading-relaxed mb-4">"{r.text}"</blockquote>
            <figcaption className="flex items-center justify-between gap-2">
              <div className="flex items-center gap-2 min-w-0">
                {r.photo && <img src={r.photo} alt="" className="w-7 h-7 rounded-full shrink-0" loading="lazy" referrerPolicy="no-referrer" />}
                <p className="text-white font-semibold text-sm truncate">{r.author || 'Cliente Google'}</p>
              </div>
              {r.review_uri && (
                <a href={r.review_uri} target="_blank" rel="noopener noreferrer"
                  className="inline-flex items-center gap-1 text-cyan-400 hover:text-cyan-300 text-xs shrink-0">
                  Ver no Google <ExternalLink className="w-3 h-3" />
                </a>
              )}
            </figcaption>
          </figure>
        ))}
      </div>
      <div className="flex flex-col sm:flex-row items-center justify-center gap-2 mt-6">
        <p className="text-slate-500 text-xs">Avaliações exibidas na ordem de relevância do Google.</p>
        {data.maps_uri && (
          <a href={data.maps_uri} target="_blank" rel="noopener noreferrer"
            className="inline-flex items-center gap-1.5 text-slate-400 hover:text-white text-xs font-medium transition-colors">
            <GoogleIcon /> Ver todas no Google Maps <ExternalLink className="w-3 h-3" />
          </a>
        )}
      </div>
    </article>
  );
};

export default DepoimentosSection;
